module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/signup-modal-horizontal-39dcaef9e9ef996429c08c12a5d42efa.jpg";